import Vue from 'vue'
import Router from 'vue-router'
import privateRoutes from './privateRoute';
import Strapi from 'strapi-sdk-javascript';
import definedPermission from '@/store/config/permissions'

// Strapi
// 'http://localhost:1337'
const strapi = new Strapi('https://cms.soch3d.com/');
strapi.verifyToken = async(token) => {
  let valid = await strapi.axios.post('/token/decrypt',{token})
  .then(function (response) {
    return (response && !response.data) ? false : response;
  })
  .catch(function (error) {
    console.log(error);
    return false;
  });
  return valid;
};

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Orders = () => import('@/views/pages/Orders')
const Quotes = () => import('@/views/pages/Quotes')

const Dashboard = () => import('@/views/pages/soch3dDashboard')

// const Colors = () => import('@/views/theme/Colors')
// const Typography = () => import('@/views/theme/Typography')

// const Charts = () => import('@/views/Charts')
// const Widgets = () => import('@/views/Widgets')

// Views - Components
// const Cards = () => import('@/views/base/Cards')
// const Forms = () => import('@/views/base/Forms')
// const Switches = () => import('@/views/base/Switches')
// const Tables = () => import('@/views/base/Tables')
// const Tabs = () => import('@/views/base/Tabs')
// const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
// const Carousels = () => import('@/views/base/Carousels')
// const Collapses = () => import('@/views/base/Collapses')
// const Jumbotrons = () => import('@/views/base/Jumbotrons')
// const ListGroups = () => import('@/views/base/ListGroups')
// const Navs = () => import('@/views/base/Navs')
// const Navbars = () => import('@/views/base/Navbars')
// const Paginations = () => import('@/views/base/Paginations')
// const Popovers = () => import('@/views/base/Popovers')
// const ProgressBars = () => import('@/views/base/ProgressBars')
// const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
// const StandardButtons = () => import('@/views/buttons/StandardButtons')
// const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
// const Dropdowns = () => import('@/views/buttons/Dropdowns')
// const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
// const Flags = () => import('@/views/icons/Flags')
// const FontAwesome = () => import('@/views/icons/FontAwesome')
// const SimpleLineIcons = () => import('@/views/icons/SimpleLineIcons')
// const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')

// Views - Notifications
// const Alerts = () => import('@/views/notifications/Alerts')
// const Badges = () => import('@/views/notifications/Badges')
// const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const ForgetPassword = () => import('@/views/pages/ForgetPassword')
// const Register = () => import('@/views/pages/Register')

// Users
// const Users = () => import('@/views/users/Users')
// const User = () => import('@/views/users/User')

Vue.use(Router)


function getPermittedRoutes(store){
  let permittedRoutes = [];
  let permissions = store.getters.canAccess({configkey:'permissions'});
  Object.values(definedPermission).map(e=>{
    if(permissions.includes(e)){
      let singleRoute = {
        component: {
          render (c) { return c('router-view') }
        },
        children:[]
      };

      if(e.includes('QUOTE')){
        singleRoute.path = 'quotes';
        singleRoute.redirect= '/orders/assigned';
        singleRoute.name='Quotes';
        switch(e){
          case 'QUOTE_CREATE':
              singleRoute.children.push({
                path:'create/:oid',
                name: 'Create Quote',
                component: Quotes
              });
              break;
          case 'QUOTE_UPDATE':
              singleRoute.children.push({
                path:'edit/:id/:oid',
                name: 'Edit Quote',
                component: Quotes
              });
              break;
        }
        permittedRoutes.push(singleRoute);
      };
    }
  });
  return permittedRoutes;
}

export default (store)=>{
  
  const configRoutes = function(){
    // Initialize Routes
    const customRoutes = getPermittedRoutes(store);
    return [
      {
        path: '/',
        redirect: '/dashboard',
        name: 'Home',
        component: DefaultContainer,
        children: [
          {
              path: 'dashboard',
              name: 'Dashboard',
              component: Dashboard
          },
          {
            path: 'orders',
            redirect: '/orders/assigned',
            name: 'Orders',
            component: {
              render (c) { return c('router-view') }
            },
            children:[
              {
                path:'assigned',
                name: 'Assigned Orders',
                component: Orders
              },
              {
                path:'completed',
                name: 'Completed Orders',
                component: Orders
              }
            ]
          },
          ...customRoutes
        ]
          // [
          // {
          //   path: 'dashboard',
          //   name: 'Dashboard',
          //   component: Dashboard
          // },
          // {
          //   path: 'theme',
          //   redirect: '/theme/colors',
          //   name: 'Theme',
          //   component: {
          //     render (c) { return c('router-view') }
          //   },
          //   children: [
          //     {
          //       path: 'colors',
          //       name: 'Colors',
          //       component: Colors
          //     },
          //     {
          //       path: 'typography',
          //       name: 'Typography',
          //       component: Typography
          //     }
          //   ]
          // },
          // {
          //   path: 'charts',
          //   name: 'Charts',
          //   component: Charts
          // },
          // {
          //   path: 'widgets',
          //   name: 'Widgets',
          //   component: Widgets
          // },
          // {
          //   path: 'users',
          //   meta: { label: 'Users'},
          //   component: {
          //     render (c) { return c('router-view') }
          //   },
          //   children: [
          //     {
          //       path: '',
          //       component: Users,
          //     },
          //     {
          //       path: ':id',
          //       meta: { label: 'User Details'},
          //       name: 'User',
          //       component: User,
          //     },
          //   ]
          // },
          // {
          //   path: 'base',
          //   redirect: '/base/cards',
          //   name: 'Base',
          //   component: {
          //     render (c) { return c('router-view') }
          //   },
          //   children: [
          //     {
          //       path: 'cards',
          //       name: 'Cards',
          //       component: Cards
          //     },
          //     {
          //       path: 'forms',
          //       name: 'Forms',
          //       component: Forms
          //     },
          //     {
          //       path: 'switches',
          //       name: 'Switches',
          //       component: Switches
          //     },
          //     {
          //       path: 'tables',
          //       name: 'Tables',
          //       component: Tables
          //     },
          //     {
          //       path: 'tabs',
          //       name: 'Tabs',
          //       component: Tabs
          //     },
          //     {
          //       path: 'breadcrumbs',
          //       name: 'Breadcrumbs',
          //       component: Breadcrumbs
          //     },
          //     {
          //       path: 'carousels',
          //       name: 'Carousels',
          //       component: Carousels
          //     },
          //     {
          //       path: 'collapses',
          //       name: 'Collapses',
          //       component: Collapses
          //     },
          //     {
          //       path: 'jumbotrons',
          //       name: 'Jumbotrons',
          //       component: Jumbotrons
          //     },
          //     {
          //       path: 'list-groups',
          //       name: 'List Groups',
          //       component: ListGroups
          //     },
          //     {
          //       path: 'navs',
          //       name: 'Navs',
          //       component: Navs
          //     },
          //     {
          //       path: 'navbars',
          //       name: 'Navbars',
          //       component: Navbars
          //     },
          //     {
          //       path: 'paginations',
          //       name: 'Paginations',
          //       component: Paginations
          //     },
          //     {
          //       path: 'popovers',
          //       name: 'Popovers',
          //       component: Popovers
          //     },
          //     {
          //       path: 'progress-bars',
          //       name: 'Progress Bars',
          //       component: ProgressBars
          //     },
          //     {
          //       path: 'tooltips',
          //       name: 'Tooltips',
          //       component: Tooltips
          //     }
          //   ]
          // },
          // {
          //   path: 'buttons',
          //   redirect: '/buttons/standard-buttons',
          //   name: 'Buttons',
          //   component: {
          //     render (c) { return c('router-view') }
          //   },
          //   children: [
          //     {
          //       path: 'standard-buttons',
          //       name: 'Standard Buttons',
          //       component: StandardButtons
          //     },
          //     {
          //       path: 'button-groups',
          //       name: 'Button Groups',
          //       component: ButtonGroups
          //     },
          //     {
          //       path: 'dropdowns',
          //       name: 'Dropdowns',
          //       component: Dropdowns
          //     },
          //     {
          //       path: 'brand-buttons',
          //       name: 'Brand Buttons',
          //       component: BrandButtons
          //     }
          //   ]
          // },
          // {
          //   path: 'icons',
          //   redirect: '/icons/font-awesome',
          //   name: 'Icons',
          //   component: {
          //     render (c) { return c('router-view') }
          //   },
          //   children: [
          //     {
          //       path: 'coreui-icons',
          //       name: 'CoreUI Icons',
          //       component: CoreUIIcons
          //     },
          //     {
          //       path: 'flags',
          //       name: 'Flags',
          //       component: Flags
          //     },
          //     {
          //       path: 'font-awesome',
          //       name: 'Font Awesome',
          //       component: FontAwesome
          //     },
          //     {
          //       path: 'simple-line-icons',
          //       name: 'Simple Line Icons',
          //       component: SimpleLineIcons
          //     }
          //   ]
          // },
          // {
          //   path: 'notifications',
          //   redirect: '/notifications/alerts',
          //   name: 'Notifications',
          //   component: {
          //     render (c) { return c('router-view') }
          //   },
          //   children: [
          //     {
          //       path: 'alerts',
          //       name: 'Alerts',
          //       component: Alerts
          //     },
          //     {
          //       path: 'badges',
          //       name: 'Badges',
          //       component: Badges
          //     },
          //     {
          //       path: 'modals',
          //       name: 'Modals',
          //       component: Modals
          //     }
          //   ]
          // }
        // ]
      },
      {
        path: '/404',
        name: 'Page404',
        component: Page404
      },
      {
        path: '/500',
        name: 'Page500',
        component: Page500
      },
      {
        path: '/login',
        name: 'Login',
        component: Login
      },
      {
        path: '/forget-password',
        name: "forgetpassword",
        component: ForgetPassword
      },
      // {
      //   path: '/register',
      //   name: 'Register',
      //   component: Register
      // },
      {
        path:'*',
        redirect: '/login',
      }
    ]
  }


  //  Ensure Protected Routes
  const router= new Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: configRoutes()
  });

  router.beforeEach(async (to, from, next) => {
    let verified = false;
    if(localStorage){
      let token = JSON.parse(localStorage.getItem('jwt'));
      verified = await strapi.verifyToken( token || '');
      if(!verified) localStorage.clear();
    }

    if (privateRoutes.includes(to.fullPath)) {
      if(verified) return next();
      next('/login');
    }

    if (['/login'].includes(to.fullPath)) {
      if(verified) return next('/orders');
      next();
    }
    next();
  });
  return router;
};
